import { LoadingModule, Table } from '@domain-group/suit-theme'

import useServiceProduct from '@hooks/useServiceProduct'
import useActivities from '@hooks/useActivities'

import PageLayout from '../../../../components/PageLayout'
import NoResultsBlankState from '../NoResultsBlankState'

interface PageContentProps {
  serviceProductId: number,
}
const PageContent = (props: PageContentProps) => {
  const { serviceProductId } = props

  const serviceProductPayload = useServiceProduct({ id: serviceProductId })

  // Fetch activities for this ServiceProduct
  const { filteredActivities, loading } = useActivities({
    filters: {
      trackable_only: true,
      recipient_type: 'ServiceProduct',
      recipient_id: serviceProductId,
    },
    performHttpRequests: true,
  })

  const format = (v: unknown) => (typeof v === 'object' && v !== null ? JSON.stringify(v) : String(v))

  function formatOptionChanges(options: unknown): string | null {
    if (!Array.isArray(options) || options.length !== 2) return null
    const [oldOptions, newOptions] = options
    return Object.keys({ ...oldOptions, ...newOptions })
      .map((key) => {
        const oldValue = oldOptions?.[key]
        const newValue = newOptions?.[key]
        const oldStr = format(oldValue)
        const newStr = format(newValue)
        if (oldStr === newStr) return null
        return `options.${key}: ${oldStr} => ${newStr}`
      })
      .filter(Boolean)
      .join('\n') || null
  }

  const transformedActivities = filteredActivities?.map((activity) => {
    const changes = activity.parameters?.changes || {}

    const mainChanges = Object.entries(changes)
      .filter(([attr]) => attr !== 'options')
      // @ts-expect-error TS18046
      .map(([attr, values]) => `${attr}: ${values[0]} => ${values[1]}`)
      .join('\n') || null

    // @ts-expect-error TS2339
    const formattedOptionChanges = formatOptionChanges(changes.options)

    return {
      ...activity,
      createdAt: activity.dates?.created?.date_time || null,
      owner: `${activity.owner_type}: ${activity.owner_id}`,
      changes: mainChanges,
      optionChanges: formattedOptionChanges,
    }
  })

  const tableColumns = [
    {
      title: 'Activity',
      dataKey: 'createdAt',
      cellProps: {
        left: '0%',
        width: '15%',
        style: { whiteSpace: 'normal', wordBreak: 'break-word' },
      },
    },
    {
      title: 'Owner',
      dataKey: 'owner',
      cellProps: {
        left: '15%',
        width: '10%',
        style: { whiteSpace: 'normal', wordBreak: 'break-word' },
      },
      render: (value?: string) => (value ? (
        <pre
          style={{
            margin: 0,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          {value}
        </pre>
      ) : null),
    },
    {
      title: 'Changes',
      dataKey: 'changes',
      cellProps: {
        left: '25%',
        width: '40%',
        style: { whiteSpace: 'normal', wordBreak: 'break-word' },
      },
      render: (value?: string) => (value ? (
        <pre
          style={{
            margin: 0,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          {value}
        </pre>
      ) : null),
    },
    {
      title: 'Option Changes',
      dataKey: 'optionChanges',
      cellProps: {
        left: '65%',
        width: '40%',
        style: { whiteSpace: 'normal', wordBreak: 'break-word' },
      },
      render: (value?: string) => (value ? (
        <pre
          style={{
            margin: 0,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          {value}
        </pre>
      ) : null),
    },
  ]

  return (
    <PageLayout entityPayload={serviceProductPayload} activeTabBarItemKey="auditLog">
      {loading && <LoadingModule loading={loading} times={1} />}

      {!loading && filteredActivities && filteredActivities.length === 0 && <NoResultsBlankState />}

      {!loading && filteredActivities && filteredActivities.length > 0 && (

      <Table
        // @ts-expect-error TS2322
        columns={tableColumns}
        data={transformedActivities}
      />

      )}
    </PageLayout>
  )
}

export default PageContent
